var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSupplyChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,58V70a.7502.7502,0,0,0,.75.75H22a.7502.7502,0,0,0,.75-.75V58a.7502.7502,0,0,0-.75-.75H10A.7502.7502,0,0,0,9.25,58Zm1.5.75h4.5V64h1.5V58.75h4.5v10.5H10.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70,9.25H58a.7502.7502,0,0,0-.75.75V22a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V10A.7502.7502,0,0,0,70,9.25Zm-.75,12H58.75v-4.5h10.5Zm0-6H58.75v-4.5h10.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28,15.25c-10.13477,0-14.75,6.60938-14.75,12.75S17.86523,40.75,28,40.75H52c9.10352,0,13.25,5.83154,13.25,11.25S61.10352,63.25,52,63.25H26v1.5H52c10.13477,0,14.75-6.60938,14.75-12.75S62.13477,39.25,52,39.25H28c-9.10352,0-13.25-5.83154-13.25-11.25S18.89648,16.75,28,16.75H52.18945l-4.71972,4.71973,1.06054,1.06054,6-6a.74972.74972,0,0,0,0-1.06054l-6-6-1.06054,1.06054L52.18945,15.25H28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupplyChain);
export default __webpack_public_path__ + "static/media/icon_supply_chain.eda917a60343c26495e50a74451bd8c3.svg";
export { ForwardRef as ReactComponent };